import React, { Component } from 'react';
import { HomeStyle } from './homeComp';
import $ from 'jquery';
import request from 'utils/request';
import { message } from 'antd';
import Loading from 'components/Loading';
import { getCookie, baiduStatistics } from 'utils';
import { global } from 'config';

export default class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {
            banner: [
                {
                    id: 1,
                },
                {
                    id: 2,
                },
                {
                    id: 3,
                },
                {
                    id: 1,
                },
            ],
            mask: false
        }
    }

    componentDidMount() {
        baiduStatistics();

        this.requestList();

    }

    banner = banner => {
        let num = 1;

        function start(dir) {
            // console.log('start', num);

            if (num >= banner.length) {
                num = 1;
                $('.banner-list').css({
                    left: '0px'
                });
            }

            let left = -1000 * num;
            $('.banner-list').delay(600).animate({
                left
            });
            num++;
        }

        function stop() {
            $('.banner-list').stop(true, true);
            clearInterval(timer);
        }

        let timer = setInterval(start, 1600);

        $('.home-banner').hover(() => {
            stop();
        }, () => {
            timer = setInterval(start, 1600);
        });

        $('.banner-tol').click(() => {
            stop();
            // console.log('left', num);
            if (num >= banner.length) {
                num = 1;
                $('.banner-list').css({
                    left: 0
                });
            }
            $('.banner-list').animate({
                left: -1000 * num
            });
            num++;
        });

        $('.banner-tor').click(() => {
            stop();
            // console.log('right', num);
            if (num <= 1) {
                num = banner.length;
                $('.banner-list').css({
                    left: -(banner.length - 1) * 1000
                });
            }
            $('.banner-list').animate({
                left: -1000 * (num - 2)
            });
            num--;
        });
    }

    requestList = () => {
        request({
            url: 'huhuapi/Anchor/indexManager',
            // method: 'post',
            // data: {
            //     age_id: 3,
            //     isnewui: 1
            // }
        }).then(res => {
            // console.log(res.data);
            if (res.data.status) {
                let banner_list = [].concat(res.data.data.banner_list, res.data.data.banner_list[0]);

                this.setState({
                    app_index: res.data.data.index_list,
                    banner_list
                });

                this.banner(banner_list);
                // this.banner(this.state.banner);
            } else {
                message.info(res.data.errorStr);
            }
        }).catch(err => console.log(err));
    }

    renderBanner = () => {
        const { banner_list } = this.state;

        // function rgb() {//rgb颜色随机
        //     var r = Math.floor(Math.random() * 256);
        //     var g = Math.floor(Math.random() * 256);
        //     var b = Math.floor(Math.random() * 256);
        //     var rgb = '(' + r + ',' + g + ',' + b + ')';
        //     return 'rgb' + rgb;
        // }

        // return banner.map((item, index) => <img src={item.image} alt="" style={{ background: rgb() }} className="banner-item" key={index} />)
        return banner_list.length && banner_list.map((item, index) => <div onClick={this.changeMask} style={{ background: `url(${item.image}) no-repeat center`, backgroundSize: 'cover', cursor: 'pointer' }} alt="" className="banner-item" key={index} ></div>)
    }

    jumpAlbumDetail = (item) => {
        const { history: { push } } = this.props;

        push(`/detail?id=${item.id}`);
    }

    // 页面刷新
    reload = () => {
        window.location.reload();
    }

    // 主播入口
    goPlatform = () => {
        const { push } = this.props.history;
        let token = getCookie('token');

        if (token) {
            push('/platform');
        } else {
            push('/login');
        }
    }

    renderList = () => {
        const { app_index } = this.state;
        // console.log(app_index);

        return app_index && app_index.map((item, index) => <div className="home-item" key={item.id}>
            <h1 className="home-main-title">{item.name}</h1>
            <div className="home-list">
                {item.app_index_detail.map((val, i) => <div key={val.id} className="item" onClick={() => this.jumpAlbumDetail(val)} style={{ marginRight: (i + 1) % 4 === 0 ? '0' : '', cursor: 'pointer' }}>
                    <img src={val.image} className="item-img" alt={val.name} />
                    <h2 className="text">{val.name}</h2>
                    <div className="intro">{val.introduction}</div>
                    {val.vip_type ? <img src={require("images/home/can.png")} className="can" alt="" /> : ''}
                </div>)}
            </div>
        </div>);
    }

    changeMask = () => {
        const { mask } = this.state;

        this.setState({
            mask: !mask
        });
    }

    render() {
        const { banner_list, app_index, mask } = this.state;

        const { history: { push } } = this.props;

        return (<HomeStyle>
            {banner_list && app_index
                ? <div className="home-kfpt">
                    <header className="home-header">
                        <div className="wrapper">
                            <img src={require('images/home/logo.png')} onClick={() => push('/home')} className="home-logo" alt="呼呼收音机" title="首页" />
                            <div className="home-header-right">
                                <div className="entry" onClick={this.goPlatform}>主播入口</div>
                                <div className="down" onClick={this.changeMask}>下载APP</div>
                            </div>
                        </div>
                    </header>
                    <div className="wrapper1">
                        <div className="home-banner">
                            <img className="banner-tol" alt="" src={require('images/home/toleft.png')}></img>
                            <div className="banner-list">
                                {this.renderBanner()}
                            </div>
                            <img className="banner-tor" alt="" src={require('images/home/toright.png')}></img>
                        </div>
                        <div className="home-main">
                            {this.renderList()}
                        </div>
                    </div>
                    <footer className="home-footer">
                        <div className="footer-top">
                            <div className="word1">
                                <span style={{ fontWeight: 'bold', fontSize: '15px' }}>客服联系方式</span><br />
                                <span style={{ fontWeight: 'bold', fontSize: '15px' }}>公众号</span>：呼呼收音机（id：huhustory）<br />
                                {/* <span style={{ fontWeight: 'bold', fontSize: '15px' }}>联系电话</span>：0571-56716607<br /> */}
                                <span style={{ fontWeight: 'bold', fontSize: '15px' }}>邮箱</span>：huhu@hezi.com<br />
                                （工作时间：工作日9:00-18:00）
                            </div>
                            <div className="word2">
                                <a style={{ color: '#fff' }} href={global.href + "simple/user"} target="_blank" alt="用户协议" rel="noopener noreferrer">用户协议</a><br />
                                <a style={{ color: '#fff' }} href={global.href + "simple/privacy"} target="_blank" alt="隐私协议" rel="noopener noreferrer">隐私协议</a><br />
                                <a style={{ color: '#fff' }} href={global.href + "simple/complaint"} target="_blank" alt="版权投诉指引" rel="noopener noreferrer">版权投诉指引</a><br />
                            举报邮箱：jubao@hezi.com
                            </div>
                            <div className="footer-i" style={{ marginRight: '52px' }}>
                                <img alt="APP下载" src={require('images/home/huhustory.png')} />
                                <div className="text">APP下载</div>
                            </div>
                            <div className="footer-i">
                                <img alt="公众号" src={require('images/home/wxgzh.png')} />
                                <div className="text">公众号</div>
                            </div>

                        </div>
                        <div className="footer-bottom" style={{ marginTop: '43px' }}>
                            <div className="foot-tip" style={{ marginRight: '54px' }}>增值电信业务经营许可证：浙B2-20200237</div>
                            <a href="http://www.beian.miit.gov.cn" target="_blank" className="foot-tip" rel="noopener noreferrer">浙ICP备19051259号-1</a>
                        </div>

                        <div className="footer-bottom" ><div className="foot-tip">杭州叽里咕噜文化传播有限公司© All Rights Reserved. </div></div>
                        <div className="footer-bottom" ><div className="foot-tip">本平台为信息网络存储空间网络服务平台</div></div>
                    </footer>
                </div> : <Loading />
            }


            {mask && <div className="mask">
                <div className="mask-dg" onClick={this.changeMask}></div>
                <div className="mask-con">
                    <img alt="" src={require('images/home/ssssss.png')} className="icon" />
                    <img alt="APP下载" src={require('images/home/huhustory.png')} className="down" />
                    <div className="title">扫码下载呼呼收音机收听更多故事</div>
                    <img src={require('images/home/close.png')} className="close" alt="" onClick={this.changeMask} />
                </div>
            </div>}
        </HomeStyle>);
    }
}

